import { create } from 'zustand';
import {
  ActiveSessionType,
  ChangePasswordBodyType,
  ProfileDataType,
  PurchasedPackagesDataType,
  TransactionType,
} from 'typings/profile.type';
import {
  changePasswordAction,
  createInvoiceAction,
  deleteActiveSessionsAction,
  getActiveSessionsAction,
  getProfileInformationAction,
  getPurchasedPackageDataAction,
  getTransactionHistoryAction,
  setProfileInformationAction,
  createPasswordAction,
} from './action';

type ProfileType = {
  changePasswordAction: (body) => Promise<boolean>;

  changePasswordLoading: boolean;
  changePasswordError: boolean;
  createPasswordAction: (body) => Promise<void>;

  createPasswordLoading: boolean;
  createPasswordError: boolean;
  purchasedPackageData: PurchasedPackagesDataType;
  purchasedPackageLoading: boolean;
  purchasedPackageError: boolean;
  getPurchasedPackageDataAction: () => Promise<void>;

  activeSessions: ActiveSessionType[];
  activeSessionsError: boolean;
  getActiveSessionsAction: () => Promise<void>;

  sessionId: string;
  deleteActiveSessionsAction: (sessionId: string) => Promise<void>;
  transactionsHistoryData: TransactionType[];
  transactionHistoryLoading: boolean;
  transactionHistoryError: boolean;
  getTransactionHistoryAction: () => Promise<void>;

  transactionId: string;
  createInvoiceLoading: boolean;
  createInvoiceError: boolean;
  createInvoiceAction: (id: string) => Promise<void>;

  profileInformation: ProfileDataType;
  profileInformationError: boolean;
  getProfileInformationAction: () => Promise<void>;

  saveProfileInformationLoading: boolean;
  setProfileInformationAction: (data: ProfileDataType) => Promise<boolean>;
  goftionUnreadMessage: number;
  setGoftionUnreadMessage: (count: number) => void;

  setPermissionAction: (show: boolean) => void;
  permissionStatus: boolean;
  reset: () => void;
};

const initialState = {
  createPasswordLoading: false,
  createPasswordError: false,
  changePasswordLoading: false,
  changePasswordError: false,
  purchasedPackageData: null,
  purchasedPackageLoading: false,
  purchasedPackageError: false,
  activeSessions: null,
  activeSessionsError: false,
  sessionId: '',
  transactionId: '',
  transactionsHistoryData: [],
  transactionHistoryError: false,
  transactionHistoryLoading: false,
  createInvoiceLoading: false,
  createInvoiceError: false,
  profileInformation: null,
  profileInformationError: false,
  saveProfileInformationLoading: false,
  goftionUnreadMessage: 0,
  permissionStatus: false,
};

const useProfileStore = create<ProfileType>((set) => ({
  ...initialState,
  reset: (): void => set(initialState),
  changePasswordAction: async (
    body: ChangePasswordBodyType,
  ): Promise<boolean> => changePasswordAction(set, body),

  getPurchasedPackageDataAction: async (): Promise<void> =>
    getPurchasedPackageDataAction(set),

  getActiveSessionsAction: async (): Promise<void> =>
    getActiveSessionsAction(set),

  deleteActiveSessionsAction: async (sessionId): Promise<void> =>
    deleteActiveSessionsAction(set, sessionId),

  getTransactionHistoryAction: async (): Promise<void> =>
    getTransactionHistoryAction(set),

  createInvoiceAction: async (transactionId: string): Promise<void> =>
    createInvoiceAction(set, transactionId),

  createPasswordAction: async (body): Promise<void> =>
    createPasswordAction(set, body),
  getProfileInformationAction: async (): Promise<void> =>
    getProfileInformationAction(set),

  setProfileInformationAction: async (
    data: ProfileDataType,
  ): Promise<boolean> => setProfileInformationAction(set, data),
  setGoftionUnreadMessage: async (count: number): Promise<void> =>
    set({ goftionUnreadMessage: count }),
  setPermissionAction: (permissionStatus: boolean): void =>
    set({ permissionStatus }),
  permissionStatus: false,
}));

export default useProfileStore;
